import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TRANSLOCO_CONFIG, TRANSLOCO_SCOPE, TranslocoConfig, TranslocoModule } from '@ngneat/transloco';

import { translocoLoader } from './transloco.loader';

export type AvailableLang = { id: string; label: string };

const supportedLanguages = [
  { id: 'en', label: 'English' },
  { id: 'pl', label: 'Polski' },
  { id: 'de', label: 'German' },
  { id: 'ja', label: 'Japanese' },
];

export function inlineLoaderFactory(loader: any) {
  return supportedLanguages.reduce((acc: any, lang: AvailableLang) => {
    acc[lang.id] = () => loader(lang.id);
    return acc;
  }, {});
}

/**
 * Configures the Transloco Module for Apps.
 *
 * Use forRoot configuration only in app.module of apps.
 *
 * Use forChild configuration only in main module of libs.
 *
 * For a complete list of plugins check https://github.com/ngneat/transloco#plugins
 *
 * If translation loading speed needs to be improved check https://netbasal.com/optimize-user-experience-while-your-angular-app-loads-7e982a67ff1a
 *
 */
@NgModule({
  imports: [CommonModule, TranslocoModule],
  exports: [TranslocoModule],
})
export class WebTranslocoConfigModule {
  static forRoot(prodMode: boolean, availableLangs = supportedLanguages) {
    return {
      ngModule: WebTranslocoConfigModule,
      providers: [
        {
          provide: TRANSLOCO_CONFIG,
          useValue: {
            availableLangs,
            defaultLang: 'en',
            prodMode: prodMode,
            fallbackLang: 'en',
            reRenderOnLangChange: false,
            flatten: {
              aot: prodMode,
            },
          } as TranslocoConfig,
        },
        translocoLoader,
      ],
    };
  }
  static forChild(scopeName: string, loader?: any) {
    return {
      ngModule: WebTranslocoConfigModule,
      providers: loader
        ? [
            {
              provide: TRANSLOCO_SCOPE,
              useValue: {
                scope: scopeName,
                loader,
              },
            },
          ]
        : [],
    };
  }
}
